import React from 'react';
import { useTable, usePagination, useSortBy, Column } from 'react-table';
import { useHistory } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tag } from '@t/tag';

import styles from './styles.module.css';

export interface Props {
    tags: Tag[];
}

const columns: Column<Tag>[] = [
    {
        Header: 'Название',
        accessor: 'tagName',
    },
    {
        Header: 'Тип',
        accessor: (tag) => tag.tagType.map((el) => `${el.name}; `),
    },
    {
        Header: 'Категория',
        accessor: (tag) => tag.categories.map((el) => `${el.title}; `),
    },
    {
        Header: 'Описание',
        accessor: 'comment',
    },
    {
        Header: 'Иконка',
        accessor: (tag) =>
            tag.iconLink &&
            tag.iconLink.split('/')[tag.iconLink.split('/').length - 1],
    },
];

export const TagListTable: React.FC<Props> = ({ tags }) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
    } = useTable(
        {
            columns,
            data: tags || [],
            initialState: {
                pageIndex: 0,
                pageSize: 1000,
            },
        },
        useSortBy,
        usePagination
    );
    const history = useHistory();

    return (
        <>
            <table {...getTableProps()} className={styles.table}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr
                            {...headerGroup.getHeaderGroupProps()}
                            key={Math.random()}
                        >
                            {headerGroup.headers.map((column) => (
                                <th
                                    {...column.getHeaderProps(
                                        column.getSortByToggleProps()
                                    )}
                                    key={Math.random()}
                                >
                                    {column.render('Header')}
                                    <span className={styles.sorted}>
                                        <FontAwesomeIcon
                                            icon={
                                                column.isSorted
                                                    ? column.isSortedDesc
                                                        ? 'sort-up'
                                                        : 'sort-down'
                                                    : 'sort'
                                            }
                                        />
                                    </span>
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                        prepareRow(row);
                        const onClick = () => {
                            const tag = row.original;
                            history.push(`/dashboard/tags/${tag._id}`);
                        };
                        return (
                            <tr
                                {...row.getRowProps()}
                                className={styles.tableRow}
                                onClick={onClick}
                                key={Math.random()}
                            >
                                {row.cells.map((cell) => {
                                    return (
                                        <td
                                            {...cell.getCellProps()}
                                            key={Math.random()}
                                        >
                                            {cell.render('Cell')}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
};

export default TagListTable;
